module.exports = __webpack_public_path__ + "static/media/eo_tag_emt.5ee6b688.svg";